import invoiceApi from '@/services/API/invoice'
import paymentApi from '@/services/API/payment'
import moment from 'moment';
import { Message, MessageBox } from 'element-ui';
import i18n from '../../../i18n';

//WARNING => DUPLCATED IN InvoiceEditor
const actionsMap = {
  save: {
    associatedStatus: 'DRAFT'
  },
  send: {
    associatedStatus: 'SENT'
  },
  pay: {
    associatedStatus: 'PAID'
  },
  void: {
    associatedStatus: 'VOIDED'
  },
  send_manually : {
    associatedStatus: 'TO_SEND'
  }
};

/**
 * Get the status of the sales order depending on the action executed.
 * The worklfow is:
 * NONE -> draft -> confirmed -> (invoiced | packed | shipped) -> fullfiled -> closed
 * @param {String} action
 * @param {Object} salesOrderStatuses
 * @param {Object} salesOrder
 */
function getStatusFromAction(action, invoiceStatuses, invoice) {
  const saveStatus = invoice.status==null?invoiceStatuses.find(s => s.code === 'DRAFT') : invoice.status;
  return action==='save' ? saveStatus : invoiceStatuses.find(s => s.code === actionsMap[action].associatedStatus);
}

const markAs = function ({commit, state, rootState, dispatch}, {statusCode, message}){
  let invoiceToUpdate = {};
  invoiceToUpdate.status = _.find(rootState.statuses.invoiceStatuses, status=>{return status.code===statusCode});
  if(invoiceToUpdate.status==null){
    Message.error({message:"Une erreur système est survenue. Veuillez réessayer plus tard."})
  }else{

    return invoiceApi.put(state.selectedInvoice.id,invoiceToUpdate)
      .then(invoice=>{
        //La mise a jour a été un succès
        Message.success({message})
        // commit('SET_SELECTED_INVOICE_STATUS',invoiceToUpdate.status);
        dispatch('updateSelectedInvoice',invoice);
      }).catch((err)=>{
        Message.error({message:"Une erreur système est survenue. Veuillez réessayer plus tard."})
      })
  }
}

const invalidateInvoiceList = function ({ commit }) {
  // commit('SET_PAGE',1);
  commit('INVALIDATE_LIST');
}

const changePage = function({commit, dispatch}, page) {
  commit('SET_PAGE', page);
  dispatch('invalidateInvoiceList');
  dispatch('fetchInvoices')
}

const fetchPreviousPage = function({commit, state, dispatch}) {
  if (state.page > 1) {
    commit('SET_PAGE', state.page - 1);
    dispatch('invalidateInvoiceList');
    dispatch('fetchInvoices');
  }
}

const fetchNextPage = function({commit, state, dispatch}) {
  if (state.page < state.pages) {
    commit('SET_PAGE', state.page + 1);
    dispatch('invalidateInvoiceList');
    dispatch('fetchInvoices');
  }
}


function buildSearchAndFiltersParams(state){
  let params = {};
  // params.paging='no';
  params.orderBy = state.orderBy.orderName;
  params.direction = state.orderBy.direction;
  params.searchTerms = state.searchTerms;
  params.limit = state.limit;
  params.page = state.page;

  params.customerClasses=[];
   _.forEach(state.filters.checkedCustomerClasses, c=>{
    params.customerClasses.push(c);
   })
  params.sentStatus = state.filters.checkedInvoiced ? state.filters.checkedInvoiced : undefined;
  params.status = state.filters.status?state.filters.status:undefined;
  params.startDate = state.filters.date?moment(state.filters.date[0]).format("YYYY-MM-DD Z"):undefined;
  params.endDate = state.filters.date?moment(state.filters.date[1]).format("YYYY-MM-DD Z"):undefined;

  params.startPaidAt = state.filters.paidAt?moment(state.filters.paidAt[0]).format("YYYY-MM-DD Z"):undefined;
  params.endPaidAt = state.filters.paidAt?moment(state.filters.paidAt[1]).format("YYYY-MM-DD Z"):undefined;

  if(state.filters.withoutReps){
    params.withoutReps=true;
  }


  params.reps=[];
  _.forEach(state.filters.checkedReps, r=>{
   params.reps.push(r);
  })

  params.customerId = state.filters.customerId?state.filters.customerId:undefined;
  params.productId = state.filters.productId?state.filters.productId:undefined;
 return params;
}

const fetchNextInvoicesPage = function({commit, dispatch, state}){

  commit('SET_PAGE',state.page+1);
  // console.log("fetchNextCustomersPage : ", state.page);
  let params = buildSearchAndFiltersParams(state);
  commit('SET_LOADING', true);
  return invoiceApi.fetchInvoices(params).then(invoices => {
    if(invoices.count!=null){
      commit('UPDATE_INVOCIES', invoices.list);
      commit('SET_COUNT', invoices.count );
      commit('SET_PAGES', invoices.pages );
    }


    commit('SET_LOADING', false);
  });
}
//Fetch customer based on a search string
const fetchInvoices = function({ commit, state }, filters) {
  if(state.outDated){
    commit('SET_LOADING', true);

    let params = buildSearchAndFiltersParams(state);

    if(filters!=null){
      params.customerId = filters.customerId?filters.customerId:undefined;
      params.status = filters.status?filters.status:undefined;
      params.statusCode = filters.statusCode?filters.statusCode:undefined;

    }


    return invoiceApi.fetchInvoices(params).then(invoices => {
      commit('SET_INVOICES', invoices.list);
      if(invoices.count!=null){
        commit('SET_COUNT', invoices.count );
        commit('SET_PAGES', invoices.pages );
        commit('SET_PAGE', invoices.page);
      }else {
        commit('SET_COUNT', 0);
        commit('SET_PAGES', 0 );
      }
      commit('SET_LOADING', false);
    });
  }
};

const changeOrderBy = function({commit, state, dispatch}, {orderName, direction}){
  commit('SET_ORDERNAME_AND_DIRECTION', {orderName, direction});
  dispatch('invalidateInvoiceList');
  dispatch('fetchInvoices');
}

const changeSortIcon = function({commit},icon){
  commit('SET_SORT_ICON',icon);
}

let searchTimeOut = null;
const setSearchTerms = function({commit, dispatch}, searchTerms) {
  commit('SET_SEARCH_TERMS',searchTerms);
  commit('SET_PAGE', 1);
  commit('SET_LOADING', true);
  clearTimeout(searchTimeOut)
  searchTimeOut = setTimeout(() => {
    dispatch('invalidateInvoiceList');
    dispatch('fetchInvoices');
  }, 300)


}

/*
* Méthode permettant de créer une facture en se basant sur une commande déjà confirmé.
*/
const postInvoiceBasedOnSalesOrder = function({commit, state, dispatch, rootState},  salesOrder){

  let invoiceToCreate = {
    salesOrderId : salesOrder.id,
    customer : salesOrder.customer,
    billing_contact : salesOrder.billing_contact,
    shipping_contact : salesOrder.shipping_contact,
    billing_address : salesOrder.billing_address,
    shipping_address : salesOrder.shipping_address,
    adjustment : salesOrder.adjustment,
    delivery_fee : salesOrder.delivery_fee,
    sub_total : salesOrder.sub_total,
    total : salesOrder.total,
    taxes : salesOrder.taxes,
    notes : salesOrder.notes,
    lines : salesOrder.items,
    date : moment(),
  }

  if(salesOrder.customer.invoice_term.value=="END_MONTH"){
    invoiceToCreate.due_date = moment(invoiceToCreate.date).endOf('month');
  }else if(salesOrder.customer.invoice_term.value=="END_NEXT_MONTH"){
    invoiceToCreate.due_date = moment(invoiceToCreate.date).endOf('month').add(1,'month')
  }else{
    invoiceToCreate.due_date = moment(invoiceToCreate.date).add(moment.duration(salesOrder.customer.invoice_term.value).asDays(),'days');
  }

  invoiceToCreate.status = getStatusFromAction('save', rootState.statuses.invoiceStatuses,invoiceToCreate);

  return invoiceApi.post(invoiceToCreate)
    .then(invoice=>{
      dispatch('invalidateInvoiceList');
      return invoice;
    })
}

const setStatusFilters = function({commit, dispatch}, statusFilter){
  commit('SET_STATUS_FILTER', statusFilter);
  dispatch('invalidateInvoiceList');
  commit('SET_PAGE', 1);
  dispatch('fetchInvoices');
}

const setDateFilters = function({commit, dispatch}, dateFilter){
  commit('SET_DATE_FILTER', dateFilter);
  dispatch('invalidateInvoiceList');
  commit('SET_PAGE', 1);
  dispatch('fetchInvoices');
}

const setPaidAtFilters  = function({commit, dispatch}, paidAtFilter) {
  commit('SET_PAID_AT_FILTER', paidAtFilter);
  dispatch('invalidateInvoiceList');
  commit('SET_PAGE', 1);
  dispatch('fetchInvoices');
}

const resetFilters = function({commit, dispatch}, event){
  if(event!=null)event.stopPropagation();
  commit('RESET_FILTERS');
  commit('SET_PAGE', 1);
  dispatch('invalidateInvoiceList');
  dispatch('fetchInvoices');
}

const selectInvoice = function({commit, state}, {invoiceId, index}){
  commit('SET_LOADING_INVOICE', true);

  return invoiceApi.get((invoiceId||state.invoices[index].id))
    .then(invoice=>{

        commit('SET_SELECTED_INVOICE', invoice);
        commit('SET_SELECTED_INDEX', index);
        commit('SET_LOADING_INVOICE', false);
    })
}

const downloadInvoiceReport = function({commit,state}, invoice){
  commit('SET_INVOICE_DOWNLOADING',true);

  let invoiceId = invoice?invoice.id:state.selectedInvoice.id;
  let invoiceNumber = invoice?invoice.inv_number:state.selectedInvoice.inv_number;
  if (invoiceNumber == null ) {
    invoiceNumber = invoice?invoice.invNumber:state.selectedInvoice.invNumber;
  }

  let filename = invoiceNumber;

  invoiceApi.downloadInvoiceReport(invoiceId, filename)
    .then(()=>{
      commit('SET_INVOICE_DOWNLOADING',false);
    })
}

const updateSelectedInvoice = function({commit, state}, invoice){
  return invoiceApi.get(state.selectedInvoice.id)
    .then(invoice=>{
      commit('UPDATE_SELECTED_INVOICE', invoice);
      commit('SET_LOADING_INVOICE', false);
    })

}

const deleteInvoiceFile = function({commit}, {invoiceId, id}){
  invoiceApi.deleteFile(invoiceId, id)
    .then(()=>{
      commit('DELETE_SELECTED_INVOICE_FILE', id);
    })
}

const addPaymentInfo = function ({state,commit, rootState}, {payment, invoiceId}){
  commit('UPDATE_OUTSTANDING_AMOUNT', {paid :payment.amount, invoiceId});
  if(state.selectedInvoice!=null && state.selectedInvoice.id == invoiceId){
    commit("ADD_PAYMENT_TO_SELECTED_INVOICE", payment);
    let status = null;
    if(state.selectedInvoice.balance.outstanding==0){
      status = _.find(rootState.statuses.invoiceStatuses, status=>{return status.code==='PAID'});

    }else{
      status = _.find(rootState.statuses.invoiceStatuses, status=>{return status.code==='PARTIALLY_PAID'});
    }
    commit('UPDATE_SELECTED_INVOICE_STATUS',status);
  }
}

const deleteSelectedInvoicePayment = function({state, commit, dispatch}, {index, payment}){

  return paymentApi.delete(payment.id)
    .then(()=>{
      commit('DELETE_SELECTED_INVOICE_PAYMENT', {index, payment});
      dispatch('updateSelectedInvoice')
      return true;
    })

}

const changeCustomerClassFilter = function({commit, dispatch}, checkedCustomerClasses){
  commit('CHANGE_CHECKED_CUSTOMER_CLASSES_FILTER', checkedCustomerClasses);
  dispatch('invalidateInvoiceList');
  commit('SET_PAGE', 1);
  dispatch('fetchInvoices');
}

const changeInvoicedFilter = function({commit, dispatch}, checkedInvoiced){
  commit('CHANGE_INVOICED_FILTER', checkedInvoiced);
  dispatch('invalidateInvoiceList');
  commit('SET_PAGE', 1);
  dispatch('fetchInvoices');
}



const validateCreationOfCreditNote=function({state}){
  if(state.selectedInvoice.creditNote!=null && state.selectedInvoice.creditNote.length>0){
    Message.error("Impossible de créer une nouvelle note crédit car la facture à déjà une note de crédit d'associée!");
    return false;
  }else{
    return true;
  }
}

const deleteCreditNote = function({state, dispatch}, {invoiceId, creditNoteId}){
  return MessageBox.confirm('Voulez-vous vraiment supprimer ce crédit de la facture. Cette action sera irréversible. Voulez-vous continuer?','Attention',{
    confirmButtonText: 'Oui',
    cancelButtonText: 'Non',
    type: 'warning'
  }).then(()=>{
    return invoiceApi.deleteInvoiceCreditNote(invoiceId, creditNoteId)
      .then(invoice=>{
        dispatch('updateSelectedInvoice')
      })
  }).catch(()=>{/* do nothing*/})

}

const applyCreditNotesToSelectedInvoice = function({state, commit, dispatch}, creditNotes){
  commit('SET_LOADING_INVOICE', true);
  return invoiceApi.applyCreditNotes(state.selectedInvoice.id, creditNotes)
    .then(invoice=>{
      dispatch('updateSelectedInvoice', invoice);
      return dispatch('updateSelectedInvoice');
    }).catch(err=>{
      commit('SET_LOADING_INVOICE', false);
      Message.error("Une erreur est survenue. Veuillez réessayer plus tard");
      console.log(err);
    })
}

const sendInvoice = function({state, dispatch, commit}){
  commit('SET_LOADING_INVOICE', true);
  return invoiceApi.send(state.selectedInvoice.id)
    .then(invoice=>{
      dispatch('updateSelectedInvoice', invoice);
      commit('SET_LOADING_INVOICE', false);
      Message.success("La facture #"+invoice.inv_number+" a été marquée comme étant envoyées avec succès");
    }).catch(err=>{
      commit('SET_LOADING_INVOICE', false);
      if(err.response.status!=500){
        Message.error(i18n.t('invoices.errors.'+err.response.data.jse_info.errorCode));
      }else{
        Message.error("Une erreur est survenue. Veuillez réessayer plus tard");
        console.log(err);
      }

    })
}

const voidInvoice = function({state, dispatch, commit}){
  return MessageBox.confirm('Voulez-vous vraiment annuler cette facture?','Attention',{
    confirmButtonText: 'Oui',
    cancelButtonText: 'Non',
    type: 'warning'
  }).then(()=>{
    commit('SET_LOADING_INVOICE', true);
    return invoiceApi.void(state.selectedInvoice.id)
      .then(invoice=>{
        dispatch('updateSelectedInvoice', invoice);
        commit('SET_LOADING_INVOICE', false);
        Message.success("La facture #"+invoice.inv_number+" a été annulée avec succès");
      }).catch(err=>{
        commit('SET_LOADING_INVOICE', false);
        if(err.response.status!=500){
          Message.error(i18n.t('invoices.errors.'+err.response.data.jse_info.errorCode));
        }else{
          Message.error("Une erreur est survenue. Veuillez réessayer plus tard");
          console.log(err);
        }

      })
  }).catch(err=>{/*do nothing*/})

}

const deleteSelectedInvoice = function({state, dispatch, commit}){
  return MessageBox.confirm('Voulez-vous vraiment supprimer cette facture. Cette action sera irréversible. Voulez-vous continuer?','Attention',{
    confirmButtonText: 'Oui',
    cancelButtonText: 'Non',
    type: 'warning'
  }).then(()=>{
    commit('SET_LOADING_INVOICE', true);
    return invoiceApi.delete(state.selectedInvoice.id)
      .then(()=>{
        dispatch('invalidateInvoiceList');
        dispatch('fetchInvoices')
        commit('SET_LOADING_INVOICE', false);
        Message.success("La facture a été supprimée avec succès");
      }).catch(err=>{
        commit('SET_LOADING_INVOICE', false);
        Message.error("Une erreur est survenue. Veuillez réessayer plus tard");
      })
  }).catch(err=>{
    /* do nothing */
  })

}

const setCheckedReps = function({commit, dispatch}, checkedReps){
  commit('SET_CHECKED_REPS', checkedReps);
  dispatch('invalidateInvoiceList');
  commit('SET_PAGE', 1);
  dispatch('fetchInvoices');
}

const setFilterWithoutReps = function({commit, dispatch}, withoutReps){
  commit('SET_WITHOUT_REPS_FILTER', withoutReps);
  dispatch('invalidateInvoiceList');
  commit('SET_PAGE', 1);
  dispatch('fetchInvoices');
}

const setCustomerFilter = function({commit, dispatch}, customer){
  commit('SET_FILTER_CUSTOMER_ID', customer.id);
  dispatch('invalidateInvoiceList');
  commit('SET_PAGE', 1);
  dispatch('fetchInvoices')
}
const setProductFilter = function({commit, dispatch}, product){
  commit('SET_FILTER_PRODUCT_ID', product.id);
  dispatch('invalidateInvoiceList');
  commit('SET_PAGE', 1);
  dispatch('fetchInvoices')
}

const changeMode = function({commit}, mode){
  commit('SET_MODE',mode);
}


export default {
  sendInvoice,
  fetchInvoices,
  updateSelectedInvoice,
  addPaymentInfo,
  setSearchTerms,
  selectInvoice,
  invalidateInvoiceList,
  changeOrderBy,
  changeSortIcon,
  changePage,
  postInvoiceBasedOnSalesOrder,
  setStatusFilters,
  resetFilters,
  setDateFilters,
  markAs,
  downloadInvoiceReport,
  deleteInvoiceFile,
  deleteSelectedInvoicePayment,
  changeCustomerClassFilter,
  validateCreationOfCreditNote,
  deleteCreditNote,
  applyCreditNotesToSelectedInvoice,
  deleteSelectedInvoice,
  changeInvoicedFilter,
  voidInvoice,
  changeMode,
  fetchNextInvoicesPage,
  setCheckedReps,
  setFilterWithoutReps,
  setCustomerFilter,
  setProductFilter,
  setPaidAtFilters,
  fetchPreviousPage,
  fetchNextPage,
};
